"use strict";
exports.__esModule = true;
var shopId = '60acb10567b35764f577d9a7'; //'60ab7c9b587b93287d8240c2';
var location = 'https://chantecaille-hk.ecommercepartners.net'; // 'https://61694d89f1e3.ngrok.io';
var config = {
    apiUrl: location + "/api/storefront/shop/" + shopId + "/",
    storeKey: 'CHANTE_STORE_HK',
    countryNumber: '+852'
};
exports["default"] = config;
